import defaultSettings from '@/services/defaultSettings';

const API_KEYS = new Set([
  'loading',
  'error',
  'lastUpdatedAt',
  'response',
  'requestPayload',
]);

const initialState = {
  ...defaultSettings,
  loading: false,
  error: null,
  lastUpdatedAt: null,
  response: null,
  requestPayload: null,
};

function stripApiKeys(payload) {
  if (!payload || typeof payload !== 'object') return {};
  const next = { ...payload };
  API_KEYS.forEach((key) => {
    delete next[key];
  });
  return next;
}

export default function portfolioReducer(state = initialState, action) {
  switch (action.type) {
    case 'portfolio/patch':
      return { ...state, ...stripApiKeys(action.payload) };
    case 'portfolio/replace':
      return {
        ...initialState,
        ...stripApiKeys(action.payload),
      };
    case 'portfolio/reset':
      return { ...initialState };
    case 'portfolio/requestStart':
      return {
        ...state,
        loading: true,
        error: null,
        requestPayload: action.payload?.requestPayload ?? state.requestPayload,
      };
    case 'portfolio/requestSuccess':
      return {
        ...state,
        loading: false,
        error: null,
        lastUpdatedAt: new Date().toISOString(),
        response: action.payload?.response ?? null,
        requestPayload:
          action.payload?.requestPayload !== undefined
            ? action.payload.requestPayload
            : state.requestPayload,
      };
    case 'portfolio/requestFailure':
      return {
        ...state,
        loading: false,
        error: action.payload ?? 'Request failed',
      };
    default:
      return state;
  }
}

export function patchPortfolio(payload) {
  return { type: 'portfolio/patch', payload };
}

export function replacePortfolio(payload) {
  return { type: 'portfolio/replace', payload };
}

export function resetPortfolio() {
  return { type: 'portfolio/reset' };
}

export function portfolioRequestStart(requestPayload) {
  return {
    type: 'portfolio/requestStart',
    payload: { requestPayload },
  };
}

export function portfolioRequestSuccess({ response, requestPayload }) {
  return {
    type: 'portfolio/requestSuccess',
    payload: { response, requestPayload },
  };
}

export function portfolioRequestFailure(error) {
  return {
    type: 'portfolio/requestFailure',
    payload: typeof error === 'string' ? error : error?.message ?? 'Request failed',
  };
}

export function selectPortfolio(state) {
  return state.portfolio ?? initialState;
}

export function selectPortfolioMode(state) {
  return state.portfolio?.mode ?? 'singleAsset';
}

export function selectPortfolioLoading(state) {
  return Boolean(state.portfolio?.loading);
}
